import { Outlet } from 'react-router-dom';
import ReportsSidebar from './_Components/ReportsSidebar';

export default function ReportsLayout() {
  return (
    <div className="flex h-full bg-gray-50 dark:bg-gray-900">
      <ReportsSidebar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
